import React, { Component } from 'react'
import Select from 'react-select-plus'
import Icon from 'svg-inline-react'
import {
  GEO_FILTER_OPERATORS,
  FIRMOGRAPHIC_FILTER_TYPES,
  CONTINENT_LABELS,
  REGION_LABELS
} from 'app/modules/rules/constants'

import { regions } from 'components/settings/Rules/constants/regions'
import { states } from 'components/settings/Rules/constants/states'
import { countries } from 'components/settings/Rules/constants/countries'
import { continents } from 'components/settings/Rules/constants/continents'

const closeSRC = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')
const mapSRC = require('!svg-inline?removeTags=false!../us.svg')
const fullSRC = require('!svg-inline?removeTags=true!images/svg/fullscreen.svg')

const SCALE_INCREMENT = .5

const COUNTRY_FILTER_TYPES = Object.freeze([
  FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY,
  FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY
])

const STATE_FILTER_TYPES = Object.freeze([
  FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE,
  FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE
])

class ClearbitGeoFilter extends Component {

  generateDefaultState(props) {
    const defaultOptions = props.activeFilter.value
    const ifEmptyRegionDefault = (defaultOptions.length || this.isCountryFilterType(props.activeFilter.field))
      ? defaultOptions
      : regions.northeast

    return {
      selectedGeoOptions: ifEmptyRegionDefault,
      fieldType: props.activeFilter.field,
      mapScale: 1,
      dragX: 0,
      dragY: 0,
      dragStartX: 0,
      dragStartY: 0,
      isPressed: false,
    }
  }

  constructor(props) {
    super(props)
    this.state = this.generateDefaultState(props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeFilter.field !== nextProps.activeFilter.field) {
      this.setState(this.generateDefaultState(nextProps))
    }
  }

  componentDidMount() {
    this.updateParent()
  }

  updateParent = () => {
    if (this.props.onUpdateCondition) {
      return this.props.onUpdateCondition({
        operator: GEO_FILTER_OPERATORS.IS_ANY,
        value: this.state.selectedGeoOptions
      })
    }
    const canSave = this.state.fieldType && this.state.selectedGeoOptions.length
    this.props.setPageValidity(!!canSave)
    if (canSave) {
      this.props.setActiveFilter({
        field: this.state.fieldType,
        operator: GEO_FILTER_OPERATORS.IS_ANY,
        value: this.state.selectedGeoOptions
      })
    }
  }

  zoomIn = () => {
    this.setState((prevState) => {
      if (prevState.mapScale >= 3) return
      return {
        mapScale: prevState.mapScale + SCALE_INCREMENT
      }
    })
  }

  zoomOut = () => {
    this.setState((prevState) => {
      if (prevState.mapScale <= 1) return
      return {
        mapScale: prevState.mapScale - SCALE_INCREMENT
      }
    })
  }

  fullScreen = () => {
    this.setState((prevState) => {
      return {
        fullScreen: !prevState.fullScreen
      }
    })
  }

  dragMap = (event) => {
    if ((this.state.mapScale <= 1) || !this.state.isPressed) return
    const x = event.pageX - this.state.dragStartX
    const y = event.pageY - this.state.dragStartY

    this.setState({
      dragX: event.pageX,
      dragY: event.pageY
    })
  }

  pressTimer = () => {
    setTimeout(() => {
      this.setState({
        isPressed: true
      })
    }, 2000)
  }

  handleMousePress = (event) => {
    this.setState({
      dragStartX: event.pageX,
      dragStartY: event.pageY
    })

    this.pressTimer()
  }

  handleMouseUp = () => {
    clearTimeout(this.pressTimer)
    this.setState({
      isPressed: false,
    })
  }

  getStateOrCountries() {
    const types = {
      [FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE]: this.getFormattedStateOptions,
      [FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: this.getFormattedStateOptions,
      [FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY]: this.getFormattedCountryOptions,
      [FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: this.getFormattedCountryOptions
    }
    return types[this.state.fieldType]()
  }

  getFormattedCountryOptions = () => {
    const unusedCountries = _.without(Object.keys(countries), ...this.state.selectedGeoOptions)
    return unusedCountries.map((country) => { return { label: countries[country], value: country } })
  }

  getFormattedStateOptions = () => {
    const unusedStates = _.without(states, ...this.state.selectedGeoOptions)
    return unusedStates.map((state) => { return { label: state, value: state } })
  }

  getFormattedRegionOptions() {
    return [
      ...Object.keys(regions).map((region) => {
        return { label: REGION_LABELS[region], value: region }
      }),
      { label: 'Custom', value: 'custom' }
    ]
  }

  getFormattedContinentOptions() {
    return [
      ...Object.keys(continents).map((continent) => {
        return { label: CONTINENT_LABELS[continent], value: continent }
      }),
      { label: 'Custom', value: 'custom' }
    ]
  }

  addStateFromMap = (event) => {
    const stateName = document.elementFromPoint(event.clientX, event.clientY).dataset.name
    if (!!stateName) {
      if (this.state.selectedGeoOptions.includes(stateName)) {
        this.removeGeoOption(stateName)

      } else {
        this.setState((prevState) => {
          const newOptions = prevState.selectedGeoOptions.slice(0)
          newOptions.push(stateName)
          newOptions.sort()

          return {
            selectedGeoOptions: newOptions
          }
        }, this.updateParent)
      }
    }
  }

  isCountryFilterType = (field) => COUNTRY_FILTER_TYPES.includes(field)

  isStateFilterType = (field) => STATE_FILTER_TYPES.includes(field)

  removeGeoOption = (value) => {
    this.setState((prevState) => {
      return {
        selectedGeoOptions: _.without(prevState.selectedGeoOptions, value)
      }
    }, this.updateParent)
  }

  saveGeoOption = (values) => {
    this.setState((prevState) => {
      const newOptions = prevState.selectedGeoOptions.slice(0)
      const onlyValues = values.map((option) => option.value)
      newOptions.push(...onlyValues)
      newOptions.sort()

      return {
        selectedGeoOptions: newOptions
      }
    }, this.updateParent)
  }

  bucketSelect = (value) => {
    const geoType = this.isCountryFilterType(this.state.fieldType) ? continents : regions

    this.setState({ selectedGeoOptions: geoType[value.value] || [] }, this.updateParent)
  }

  chooseCountry = () => {
    this.setState({ fieldType: this.state.fieldType, selectedGeoOptions: [] }, this.updateParent)
  }

  chooseState = () => {
    this.setState({ fieldType: this.state.fieldType, selectedGeoOptions: [] }, this.updateParent)
  }

  stateOrCountryListItems() {
    const types = {
      [FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE]: this.renderStateSelectionList,
      [FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: this.renderStateSelectionList,
      [FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY]: this.renderCountrySelectionList,
      [FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: this.renderCountrySelectionList
    }
    return types[this.state.fieldType]()
  }

  renderSelectOption = ({ label }) => {
    return (
      <div className="geo-option choice-dropdown-option">
        <span className="choice-option-value">{label}</span>
        <span className="choice-option-add">+Add</span>
      </div>
    )
  }

  renderBucketSelect() {
    const formattedGeoOptions = this.isCountryFilterType(this.state.fieldType) ? this.getFormattedContinentOptions() : this.getFormattedRegionOptions()
    const geoType = this.isCountryFilterType(this.state.fieldType) ? continents : regions

    const matchedBucket = _.find(formattedGeoOptions, (value) => {
      return _.isEqual(geoType[value.value], this.state.selectedGeoOptions)
    })

    const bselectOptions = {
      multi: false,
      autoFocus: false,
      options: formattedGeoOptions,
      onChange: this.bucketSelect,
      clearable: false,
      searchable: false,
      value: matchedBucket ? matchedBucket : { label: 'Custom', value: 'custom' }
    }

    return (
      <Select {...bselectOptions} />
    )
  }

  renderSearchBar() {
    const placeholders = {
      'geoCountryCode': 'Add a country...',
      'geoState': 'Add a state...'
    }
    const selectOptions = {
      multi: true,
      autoFocus: true,
      options: this.getStateOrCountries(),
      pageSize: 10,
      optionRenderer: this.renderSelectOption,
      onChange: this.saveGeoOption,
      placeholder: placeholders[this.state.fieldType]
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderGeoTypeSelect() {
    const stateSelected = this.isCountryFilterType(this.state.fieldType) ? 'selected' : ''
    const countrySelected = this.isStateFilterType(this.state.fieldType) ? 'selected' : ''

    return (
      <fieldset className="drift-pill-set">
        <button className={`drift-button large ${countrySelected}`} onClick={this.chooseCountry}>Countries</button>
        <button className={`drift-button large ${stateSelected}`} onClick={this.chooseState}>US States</button>
      </fieldset>
    )
  }

  renderStateSelectionList = () => {
    return (
      <ul style={{ height: `${(this.state.selectedGeoOptions.length * 75) / 2 + 75}px` }} >
        {
          this.state.selectedGeoOptions.map((option) => {
            return (<li key={option}><span>{option}</span> <Icon src={closeSRC} className="remove" onClick={() => this.removeGeoOption(option)}></Icon></li>)
          })
        }
      </ul>
    )
  }

  renderCountrySelectionList = () => {
    return (
      <ul style={{ height: `${(this.state.selectedGeoOptions.length * 75) / 2 + 75}px` }} >
        {
          this.state.selectedGeoOptions.map((option) => {
            return (<li key={option}> <span>{countries[option]}</span> <Icon src={closeSRC} className="remove" onClick={() => this.removeGeoOption(option)}></Icon></li>)
          })
        }
      </ul>
    )
  }
  renderStateMap() {
    const fullScreen = this.state.fullScreen ? 'full-screen-map' : ''

    if (!this.state.isPressed) {
      setTimeout(() => {
        const map = document.getElementById('us-map')
        if (!map) return

        const paths = map.querySelectorAll(':scope > path')
        paths.forEach((path) => {
          path.style = ''
        })

        this.state.selectedGeoOptions.map((state) => {
          const path = document.querySelectorAll(`[data-name="${state}"]`)[0]
          path.style = 'fill: #b5d2e1; stroke: #fff; stroke-width: 1px;'
          path.class = 'active'
        })
      }, 200)
    }


    return (
      <div
        className={`geo-filter-us-map ${fullScreen}`}
        onClick={this.addStateFromMap}
        onMouseOver={this.dragMap}
      >
        <button className="close-map" onClick={this.fullScreen}><Icon src={closeSRC} /></button>

        <div className="geo-filter-us-map-controls">
          <button className="drift-button" onClick={this.zoomIn}>+</button>
          <button className="drift-button" onClick={this.zoomOut}>-</button>
          <button className="drift-button full" onClick={this.fullScreen}>
            <Icon src={fullSRC} />
          </button>
        </div>

        <div className="map-wrapper">
          <Icon
            src={mapSRC}
            style={{ transform: `scale(${this.state.mapScale}) translateZ(0) translateX(${this.state.dragX - this.state.dragStartX}px) translateY(${this.state.dragY - this.state.dragStartY}px)` }}
          />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-sidebar drift-form clearbit-state-buckets">
          {this.renderBucketSelect()}
        </div>
        <div className="rules-choice-options">
          {this.renderSearchBar()}
        </div>

        <div className="rules-choice-selection rules-choice-selection-multi-column">
          {(this.isStateFilterType(this.state.fieldType)) && this.renderStateMap()}
          {this.stateOrCountryListItems()}
        </div>
      </div>
    )
  }
}

export default ClearbitGeoFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/HeadquartersGeoFilter.js